const PAGE_STAGE = "Error Page"

const buildAnalyticsMetaData = defaults => {
  const data = { ...defaults, pageStage: PAGE_STAGE }

  //this should convert non-string types (except objects) to string
  const stringified = JSON.stringify(data, (key, value) =>
    typeof value === "object" ? value : value.toString()
  )

  //create JSON again
  return JSON.parse(stringified)
}

module.exports = {
  buildAnalyticsMetaData,
  PAGE_STAGE
}
